import { Box } from '@mui/system';
import { circleLineSx } from './styles';

export default function CircleLine ({
  stepNumber,
  currentStep,
  setStep,
  addMode = false,
}: {
  stepNumber: number;
  currentStep: number;
  setStep: (step: number) => void;
  addMode?: boolean;
}) {
  const line = (number: number) => (
    <div key={-number} className={'line' + (currentStep >= number ? ' line-selected' : '')}></div>
  );

  const handleSelect = (step: number) => {
    setStep(step);
  };

  const circle = (number: number) => {
    const jsx = [];
    if (number > 0) {
      jsx.push(line(number));
    }
    jsx.push(
      <div
        key={number}
        className={'circle' + (currentStep >= number ? ' circle-selected' : '')}
        onClick={e => {
          e.stopPropagation();
          handleSelect(number);
        }}
      >
        {currentStep >= number || !addMode ? number + 1 : <span>+</span>}
      </div>,
    );
    return jsx;
  };

  return <Box sx={circleLineSx}>{Array.from({ length: stepNumber }, (_, i) => i).map(number => circle(number))}</Box>;
}
